var _rect, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNoCreatorSvg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2,
    width: 40,
    height: 40,
    rx: 20,
    fill: "#D9E2EC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22 12C19.38 12 17.25 14.13 17.25 16.75C17.25 19.32 19.26 21.4 21.88 21.49C21.96 21.48 22.04 21.48 22.1 21.49C22.12 21.49 22.13 21.49 22.15 21.49C22.16 21.49 22.16 21.49 22.17 21.49C24.73 21.4 26.74 19.32 26.75 16.75C26.75 14.13 24.62 12 22 12Z",
    fill: "#004080"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.0809 24.1509C24.2909 22.2909 19.7409 22.2909 16.9309 24.1509C15.6609 25.0009 14.9609 26.1509 14.9609 27.3809C14.9609 28.6109 15.6609 29.7509 16.9209 30.5909C18.3209 31.5309 20.1609 32.0009 22.0009 32.0009C23.8409 32.0009 25.6809 31.5309 27.0809 30.5909C28.3409 29.7409 29.0409 28.6009 29.0409 27.3609C29.0309 26.1309 28.3409 24.9909 27.0809 24.1509Z",
    fill: "#004080"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoCreatorSvg);
export default __webpack_public_path__ + "static/media/noCreatorSvg.a59474e0acae227e444e349246acacfb.svg";
export { ForwardRef as ReactComponent };